"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContextMenuHelper = void 0;
var algorithms_1 = require("@devexpress/utils/lib/intervals/algorithms");
var model_iterator_1 = require("../model-iterator");
var run_type_1 = require("../runs/run-type");
var field_1 = require("./field");
var FieldContextMenuHelper = (function () {
    function FieldContextMenuHelper() {
    }
    FieldContextMenuHelper.getHyperlinkResultText = function (subDocument, field) {
        var result = "";
        var iterator = new model_iterator_1.ModelIterator(subDocument, true);
        iterator.setPosition(field.getResultStartPosition());
        var currFieldIndex = field.index;
        var fields = subDocument.fields;
        do {
            if (iterator.getAbsolutePosition() >= field.getResultEndPosition())
                break;
            switch (iterator.run.getType()) {
                case run_type_1.RunType.FieldCodeStartRun:
                    currFieldIndex++;
                    iterator.setPosition(fields[currFieldIndex].getResultStartPosition());
                    continue;
                case run_type_1.RunType.FieldResultEndRun:
                    iterator.setPosition(fields[currFieldIndex].getFieldEndPosition());
                    continue;
                case run_type_1.RunType.TextRun:
                    result += iterator.chunk.getRunText(iterator.run);
            }
        } while (iterator.moveToNextRun());
        return result;
    };
    FieldContextMenuHelper.canChangeHyperlinkDisplayText = function (subDocInterval) {
        var iterator = new model_iterator_1.ModelIterator(subDocInterval.subDocument, false);
        iterator.setPosition(subDocInterval.interval.start);
        do {
            if (iterator.getAbsolutePosition() >= subDocInterval.interval.end)
                break;
            var runType = iterator.run.getType();
            if (runType == run_type_1.RunType.InlinePictureRun ||
                runType == run_type_1.RunType.AnchoredPictureRun ||
                runType == run_type_1.RunType.AnchoredTextBoxRun ||
                runType == run_type_1.RunType.InlineTextBoxRun)
                return false;
        } while (iterator.moveToNextRun());
        return true;
    };
    FieldContextMenuHelper.showUpdateAndToogleCodeItems = function (fields, intervals) {
        if (fields.length == 0)
            return false;
        for (var intervalIndex = 0, interval; interval = intervals[intervalIndex]; intervalIndex++) {
            var intervalEnd = interval.end;
            var fieldIndex = Math.max(0, field_1.Field.normedBinaryIndexOf(fields, interval.start + 1));
            var field = fields[fieldIndex].getAbsolutelyTopLevelField();
            var topLevelField = field;
            for (fieldIndex = field.index; field = fields[fieldIndex]; fieldIndex++) {
                if (field.showCode ? field.getSeparatorPosition() < interval.start : field.getResultEndPosition() < interval.start)
                    continue;
                if (field.showCode ? field.getFieldStartPosition() >= intervalEnd : field.getResultStartPosition() > intervalEnd)
                    break;
                return true;
            }
            if (topLevelField.getFieldStartPosition() == interval.start)
                return true;
        }
        return false;
    };
    FieldContextMenuHelper.showCreateHyperlinkItem = function (fields, interval) {
        if (fields.length == 0)
            return true;
        var intervalEnd = interval.end;
        var fieldIndex = Math.max(0, field_1.Field.normedBinaryIndexOf(fields, interval.start + 1));
        var field = fields[fieldIndex].getAbsolutelyTopLevelField();
        for (fieldIndex = field.index; field = fields[fieldIndex]; fieldIndex++) {
            if (field.getFieldStartPosition() >= intervalEnd)
                break;
            if (field.getFieldEndPosition() <= interval.start)
                continue;
            return false;
        }
        return true;
    };
    FieldContextMenuHelper.showHyperlinkItems = function (fields, interval) {
        return this.getHyperlinkFieldCore(fields, interval, function (field) { return field.getAllFieldInterval(); });
    };
    FieldContextMenuHelper.getHyperlinkField = function (fields, interval) {
        return this.getHyperlinkFieldCore(fields, interval, function (field) { return field.getAllFieldIntervalWithoutBorders(); });
    };
    FieldContextMenuHelper.getHyperlinkFieldCore = function (fields, interval, fieldIntervalGetter) {
        if (fields.length == 0)
            return null;
        var fieldIndex = Math.max(0, field_1.Field.normedBinaryIndexOf(fields, interval.start + 1));
        var field = fields[fieldIndex];
        if (interval.length == 0) {
            do {
                if (fieldIntervalGetter(field).containsWithIntervalEnd(interval.start))
                    return field.isHyperlinkField() ? field : null;
                field = field.parent;
            } while (field);
            return null;
        }
        if (algorithms_1.IntervalAlgorithms.getIntersection(fieldIntervalGetter(field), interval))
            return FieldContextMenuHelper.getFinalResult(fields, interval, field);
        var parent = field.parent;
        if (parent) {
            if (algorithms_1.IntervalAlgorithms.getIntersection(fieldIntervalGetter(parent), interval))
                return FieldContextMenuHelper.getFinalResult(fields, interval, parent);
            else {
                field = FieldContextMenuHelper.getNextTopLevelField(fields, field.index);
                if (!field)
                    return null;
                return algorithms_1.IntervalAlgorithms.getIntersection(fieldIntervalGetter(field), interval) ? FieldContextMenuHelper.getFinalResult(fields, interval, field) : null;
            }
        }
        if (interval.start <= field.getFieldStartPosition())
            return null;
        field = FieldContextMenuHelper.getNextTopLevelField(fields, field.index);
        if (!field)
            return null;
        return algorithms_1.IntervalAlgorithms.getIntersection(fieldIntervalGetter(field), interval) ? FieldContextMenuHelper.getFinalResult(fields, interval, field) : null;
    };
    FieldContextMenuHelper.getNextTopLevelField = function (fields, fieldIndex) {
        var field;
        for (fieldIndex++; field = fields[fieldIndex]; fieldIndex++)
            if (!field.parent)
                break;
        return field;
    };
    FieldContextMenuHelper.getFinalResult = function (fields, interval, field) {
        if (!field)
            return null;
        if (!field.isHyperlinkField())
            return null;
        var nextTopLevelField = FieldContextMenuHelper.getNextTopLevelField(fields, field.index);
        if (nextTopLevelField && nextTopLevelField.getCodeStartPosition() <= interval.end)
            return null;
        return field;
    };
    return FieldContextMenuHelper;
}());
exports.FieldContextMenuHelper = FieldContextMenuHelper;
